import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import * as Sentry from '@sentry/angular';

import { Chart } from 'chart.js/auto';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';

// Reports v2: registra el plugin matrix una sola vez para todos los heatmaps.
Chart.register(MatrixController, MatrixElement);

registerLocaleData(localeEsMx, 'es-MX');

// Inicializa Sentry antes del bootstrap leyendo DSN desde /config.json (runtime).
// Si no hay DSN o falla el fetch, se saltea silenciosamente.
(async () => {
  try {
    const res = await fetch('/config.json', { cache: 'no-cache' });
    if (res.ok) {
      const cfg = await res.json();
      const dsn = cfg?.sentry?.dsn;
      if (dsn) {
        Sentry.init({
          dsn,
          environment: cfg?.sentry?.environment ?? 'production',
          tracesSampleRate: cfg?.sentry?.tracesSampleRate ?? 0,
          replaysSessionSampleRate: 0,
          replaysOnErrorSampleRate: 0,
        });
      }
    }
  } catch {
    // Sentry es best-effort; si no se pudo init, bootstrap sigue igual
  }

  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
})();
